@for (column of columns(); track $index) {
    <web-navigation-zero-column-item [entity]="column" [selectedEntity]="selectedEntity()" />
}
